export default "__VITE_ASSET__E1mzr3Yt__"